import { Contract } from "@edp-components/edp-contract";
import {
    ConsumptionHistory,
    ConsumptionHistoryPayload,
    ConsumptionWithDisaggregation,
    GetConsumptionPayload,
    GetConsumptionPowerPayload,
    GetSmartNowConsumptionEvolutionPayload,
    HouseCharacterization,
    SendHouseCharacterizationPayload,
    SmartNowConsumptionEvolution,
    SmartNowConsumptionsValues,
    SmartNowContractOptimization,
    SmartNowEfficiencyEnergetic,
    SmartNowNotification,
    SmartNowStatus,
    SmartNowStep,
} from "@edp-models/smart-now.model";
import { Action } from "@ngrx/store";

export enum ESmartNowActions {
    GetSmartNowStatus = "[SmartNow] Get SmartNowStatus",
    SetSmartNowStatus = "[SmartNow] Set SmartNowStatus",
    SmartNowAPIError = "[SmartNow] Get SmartNowAPIError",
    GetHouseCharacterization = "[SmartNow] Get House Characterization",
    SetHouseCharacterization = "[SmartNow] Set House Characterization",
    GetConsumptionWithDisaggregation = "[SmartNow] Get Consumption With Disaggregation",
    SetConsumptionWithDisaggregation = "[SmartNow] Set Consumption With Disaggregation",
    SetStep = "[SmartNow] Save Step",
    SendHouseCharacterization = "[SmartNow] Send House Characterization",
    SendNotification = "[SmartNow] Send Notification",
    SetPreviousStepUrl = "[SmartNow] Set Previous Step Url",
    SetFlowOrigin = "[SmartNow] Set flow origin",
    GetConsumptionPrediction = "[SmartNow] Get Consumption prediction",
    SetConsumptionPrediction = "[SmartNow] Set Consumption prediction",
    GetContractOptimization = "[SmartNow] Get contract optmization",
    SetContractOptimization = "[SmartNow] Set contract optmization",
    GetConsumptionPower = "[SmartNow] Get Consumption Power",
    SetConsumptionPower = "[SmartNow] Set Consumption Power",
    SetCurrentPeriodConsumption = "[SmartNow] Set current period consumption",
    GetConsumptionEvolution = "[SmartNow] Get evolution of consumptions",
    SetConsumptionEvolution = "[SmartNow] Set evolution of consumptions",
    GetConsumptionHistory = "[SmartNow] Get Consumption History",
    SetConsumptionHistory = "[SmartNow] Set Consumption History",
    GetEfficiencyEnergetic = "[SmartNow] Get Efficiency Energetic",
    SetEfficiencyEnergetic = "[SmartNow] Set Efficiency Energetic",
}

export class GetSmartNowStatus implements Action {
    public readonly type = ESmartNowActions.GetSmartNowStatus;
    constructor(public contract: Contract) {}
}

export class SetSmartNowStatus implements Action {
    public readonly type = ESmartNowActions.SetSmartNowStatus;
    constructor(public payload: SmartNowStatus) {}
}

export class SmartNowAPIError implements Action {
    public readonly type = ESmartNowActions.SmartNowAPIError;
    constructor(public error: Error) {}
}

export class GetHouseCharacterization implements Action {
    public readonly type = ESmartNowActions.GetHouseCharacterization;
    constructor(public contract: Contract) {}
}

export class SetHouseCharacterization implements Action {
    public readonly type = ESmartNowActions.SetHouseCharacterization;
    constructor(public payload: HouseCharacterization) {}
}

export class GetConsumptionWithDisaggregation implements Action {
    public readonly type = ESmartNowActions.GetConsumptionWithDisaggregation;
    constructor(public payload: GetConsumptionPayload) {}
}

export class SetConsumptionWithDisaggregation implements Action {
    public readonly type = ESmartNowActions.SetConsumptionWithDisaggregation;
    constructor(public payload: ConsumptionWithDisaggregation[]) {}
}

export class SetCurrentPeriodConsumption implements Action {
    public readonly type = ESmartNowActions.SetCurrentPeriodConsumption;
    constructor(public payload: ConsumptionWithDisaggregation) {}
}

export class SendHouseCharacterization implements Action {
    public readonly type = ESmartNowActions.SendHouseCharacterization;
    constructor(public payload: SendHouseCharacterizationPayload) {}
}

export class SendNotification implements Action {
    public readonly type = ESmartNowActions.SendNotification;
    constructor(public payload: SmartNowNotification) {}
}

export class SetStep implements Action {
    public readonly type = ESmartNowActions.SetStep;
    constructor(public payload: SmartNowStep) {}
}

export class SetPreviousStepUrl implements Action {
    public readonly type = ESmartNowActions.SetPreviousStepUrl;
    constructor(public payload: string) {}
}
export class SetFlowOrigin implements Action {
    public readonly type = ESmartNowActions.SetFlowOrigin;
    constructor(public payload: string) {}
}

export class GetConsumptionPrediction implements Action {
    public readonly type = ESmartNowActions.GetConsumptionPrediction;
    constructor(public contractId: string) {}
}

export class GetEfficiencyEnergetic implements Action {
    public readonly type = ESmartNowActions.GetEfficiencyEnergetic;
    constructor(public contractId: string) {}
}


export class SetEfficiencyEnergetic implements Action {
    public readonly type = ESmartNowActions.SetEfficiencyEnergetic;
    constructor(public payload: SmartNowEfficiencyEnergetic) {
    }
}



export class SetConsumptionPrediction implements Action {
    public readonly type = ESmartNowActions.SetConsumptionPrediction;
    constructor(public payload: SmartNowConsumptionsValues) {}
}

export class GetContractOptimization implements Action {
    public readonly type = ESmartNowActions.GetContractOptimization;
    constructor(public contractId: string) {}
}

export class SetContractOptimization implements Action {
    public readonly type = ESmartNowActions.SetContractOptimization;
    constructor(public payload: SmartNowContractOptimization) {}
}

export class GetConsumptionPower implements Action {
    public readonly type = ESmartNowActions.GetConsumptionPower;
    constructor(public payload: GetConsumptionPowerPayload) {}
}

export class SetConsumptionPower implements Action {
    public readonly type = ESmartNowActions.SetConsumptionPower;
    constructor(public payload: SmartNowConsumptionsValues) {}
}

export class GetConsumptionEvolution implements Action {
    public readonly type = ESmartNowActions.GetConsumptionEvolution;
    constructor(public payload: GetSmartNowConsumptionEvolutionPayload) {}
}

export class SetConsumptionEvolution implements Action {
    public readonly type = ESmartNowActions.SetConsumptionEvolution;
    constructor(public payload: SmartNowConsumptionEvolution) {}
}
export class GetConsumptionHistory implements Action {
    public readonly type = ESmartNowActions.GetConsumptionHistory;
    constructor(public payload: ConsumptionHistoryPayload) {}
}

export class SetConsumptionHistory implements Action {
    public readonly type = ESmartNowActions.SetConsumptionHistory;
    constructor(public payload: ConsumptionHistory) {}
}

export type SmartNowActions =
    | GetSmartNowStatus
    | SetSmartNowStatus
    | SmartNowAPIError
    | GetHouseCharacterization
    | SetHouseCharacterization
    | GetConsumptionWithDisaggregation
    | SetConsumptionWithDisaggregation
    | SetStep
    | SendHouseCharacterization
    | SendNotification
    | SetPreviousStepUrl
    | SetFlowOrigin
    | GetConsumptionPrediction
    | SetConsumptionPrediction
    | GetContractOptimization
    | SetContractOptimization
    | GetConsumptionPower
    | SetConsumptionPower
    | SetCurrentPeriodConsumption
    | GetConsumptionEvolution
    | SetConsumptionEvolution
    | GetConsumptionHistory
    | SetEfficiencyEnergetic
    |  GetEfficiencyEnergetic
    | SetConsumptionHistory;
